import { timeAtom } from '@/modules/api';
import { bridgeAtom, isReopenedChatAtom, store, tokenAtom } from '@/store';

export const isConfigBuilder = () => window.location.href.includes('apps/config-builder/index.html');
export const isTestUser = () => {
  const { isTestModeAvailable = true } = store.get(bridgeAtom);
  return isConfigBuilder() || (isTestModeAvailable && localStorage.getItem('testUser') === '1');
};
export const isInfluencerUser = () => sessionStorage.getItem('influencerUser') === '1';
export const isMLStagingUser = () => sessionStorage.getItem('isMLStaging') === '1';
export const isHideMetrics = () => sessionStorage.getItem('hideMetrics') === '1';
export const isDemoUser = () => isTestUser() && isHideMetrics();
export const isShopifyPreview = () => window.location.hostname.includes('shopifypreview.com');

export function getUid() {
  const devUserSession = JSON.parse(localStorage.getItem('dialogue_shopify') || '{}');
  const prodUserSession = JSON.parse(localStorage.getItem('tls_NUN8930XF6') || '{}');

  if (devUserSession && devUserSession.uid) {
    return devUserSession.uid;
  }

  return prodUserSession.uid;
}

export const isNewChat = () => {
  const time = store.get(timeAtom);
  const token = store.get(tokenAtom);
  const urlParams = new URLSearchParams(window.location.search);
  const chatIdParam = urlParams.get('chatId');
  const demoConversationIdParam = urlParams.get('demoConversationId');
  const isReopenedChat = store.get(isReopenedChatAtom);

  // chat is considered new if:
  // 1. there is no token, or time is 0
  // 2. there is no chatIdParam in the URL. Otherwise, we are trying to open an existing chat
  // 3. there is no demoConversationIdParam in the URL. Otherwise, we are trying to open an existing demo conversation
  // 4. we are not in the middle of a reopenChat flow. Otherwise, we are trying to open an existing chat/demo conversation
  return (!token || time === 0) && !chatIdParam && !demoConversationIdParam && !isReopenedChat;
};

export const getSocketUrl = () => {
  const token = store.get(tokenAtom);
  const { apiUrl, apiKey } = store.get(bridgeAtom);
  const newChat = isNewChat();

  const url = new URL(`${apiUrl}/websocket`);
  const params = new URLSearchParams({
    apiKey,
    newChat: newChat.toString(),
    customerId: window.loggedUserId || '',
  });

  if (token) {
    params.append('token', token);
  }

  url.search = params.toString();
  return url.toString();
};
